import React, { useEffect, useRef, useState } from "react";
import "./ViewYukXati.css";
import {
  Button,
  Dropdown,
  message,
  Popconfirm,
  Skeleton,
  Table,
  Tooltip,
} from "antd";
import { GoPlusCircle } from "react-icons/go";
import { Link, useNavigate, useParams } from "react-router-dom";
import { FaPrint } from "react-icons/fa6";
import { CiEdit, CiSquarePlus } from "react-icons/ci";
import {
  IoArrowBackCircleOutline,
  IoDocumentTextOutline,
} from "react-icons/io5";
import { useMessage } from "../../../Components/MessageProvider/MessageProvider";
import axiosInstance from "../../../Components/axiosInstance/AxiosInstance";
import numberToWords from "../../../Components/NumberToWords/NumberToWords";
import moment from "moment";
import { PiHamburgerThin } from "react-icons/pi";
import { MdDeleteOutline, MdOutlineIncompleteCircle } from "react-icons/md";
import { IoMdPerson } from "react-icons/io";
import { Helmet } from "react-helmet";
import formatNumberWithSpaces from "../../../Components/NumberToWords/FormatNumber";

export default function WievYukXati() {
  let navigate = useNavigate();

  let [loading, setLoading] = useState(false);
  let [data, setData] = useState(false);
  let { id } = useParams();
  let messageApi = useMessage();

  let elementRef = useRef();
  const handlePrint = () => {
    const printContent = elementRef.current;
    const WinPrint = window.open("", "", "width=900,height=900");
    // WinPrint.document.write("<html><head><title>Print</title>");
    // WinPrint.document.write(
    //   ""
    // );
    // WinPrint.document.write("</head><body>");
    WinPrint.document.write(printContent.innerHTML);
    // WinPrint.document.write("</body></html>");
    WinPrint.document.close();
    WinPrint.focus();
    WinPrint.print();
    WinPrint.close();
  };

  let getYukXati = async () => {
    try {
      setLoading(true);
      console.log(id);

      let { data } = await axiosInstance.get("/api/chiqim/" + id);

      if (data.success) {
        console.log(data);
        setData(data.data[0]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getYukXati();
  }, []);

  let sum = data?.products?.reduce((cal, curr) => {
    return cal + curr.tonna;
  }, 0);

  const confirm = async () => {
    try {
      console.log(id);
      let { data } = await axiosInstance.delete("/api/chiqim/" + id);
      console.log(data);

      message.success(id + "-Yukxati O'chdi");
      navigate("/yukxati");
    } catch (error) {
      console.log(error);
    }
  };

  const cancel = (e) => {
    console.log(e);
  };

  const items = [
    {
      key: "1",
      label: (
        <Link
          className=" block w-[100%] flex items-center justify-start gap-1"
          rel="noopener noreferrer"
          to="/yukxati"
        >
          <IoDocumentTextOutline className="font-[30px]" /> Yuk xatlari
        </Link>
      ),
    },
    {
      key: "3",
      label: (
        <Link
          className=" block w-[100%] flex items-center justify-start gap-1"
          rel="noopener noreferrer"
          to="/customers"
        >
          <IoMdPerson /> Xaridorlar
        </Link>
      ),
    },
    {
      key: "4",
      label: (
        <Link
          className=" block w-[100%] flex items-center justify-start gap-1"
          rel="noopener noreferrer"
          to="/yukxati/kirim"
        >
          <MdOutlineIncompleteCircle /> Kirimlar
        </Link>
      ),
    },
    {
      type: "divider",
    },

    {
      key: "6",
      label: (
        <div
          className=" block w-[100%] flex items-center justify-start gap-2 bg-red"
          rel="noopener noreferrer"
        >
          <Popconfirm
            title="O'chirish"
            description={"Yukxatini O'chirishga ishonchingiz komilmi?"}
            onConfirm={() => {
              confirm(id);
            }}
            onCancel={cancel}
            okText="Yes"
            cancelText="No"
          >
            {/* <span className="text-[#6b7280] text-[14px]">{i + 1}.</span>
            <span className="text-[#6b7280] text-[14px]">{row.name}</span> */}
            <div className="flex flex-row items-center justify-center gap-1">
              <MdDeleteOutline className="font-[30px]" /> O'chirish
            </div>
          </Popconfirm>
        </div>
      ),
    },
  ];

  if (loading) {
    return (
      <div>
        <div className="max-w-[900px] m-auto w-[100%] flex  bg-[#fff] z-10 flex-row  items-center justify-between p-[10px]">
          <Skeleton.Input
            active
            size="small"
            className=" text-[14px] text-[#111827] p-0 m-0 col-span-2 w-[30px] "
          />
          <Dropdown
            menu={{
              items,
            }}
            placement="topRight"
            arrow
          >
            <Button>
              <PiHamburgerThin />
            </Button>
          </Dropdown>
        </div>
        <div
          className="flex flex-col gap-6 max-w-[900px] w-[90%] m-auto"
          style={{
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {" "}
          <br></br>
          <Skeleton active />
          <br></br>
          <Skeleton active />
          {/* <Skeleton active />{" "} */}
        </div>
      </div>
    );
  }

  return (
    <div className="pb-[100px] ">
      <Helmet>
        <title>{`${data?.name} No:${data?.nakladnoy_id}   ${data?.auto_number}`}</title>
        <meta name="description" content={data?.name + "ga yozilgan yukxati"} />
        <meta property="og:title" content={data?.name} />
        <meta
          property="og:description"
          content={data?.name + "  " + data?.auto_number}
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Helmet>
      <div className="max-w-[900px] m-auto w-[100%] flex  bg-[#fff] z-10 flex-row  items-center justify-between p-[10px]">
        <Button
          onClick={() => {
            handlePrint();
          }}
          variant="solid"
          icon={<FaPrint className="font-[30px]" />}
        >
          Print
        </Button>
        <Dropdown
          menu={{
            items,
          }}
          placement="topRight"
          arrow
        >
          <Button>
            <PiHamburgerThin />
          </Button>
        </Dropdown>
      </div>
      <div className="flex justify-start gap-6 max-w-[900px] w-[100%] overflow-auto m-auto">
        <div
          class="min-w-[900px] w-[100%] font-sans"
          style={{
            paddingBottom: "30px",
          }}
        >
          <h1
            className="text-center mt-1"
            style={{
              textAlign: "center",
              fontSize: "14px",
            }}
          >
            "МИНЕРАЛ МАРКЕТ" MЧЖ СТИР: 310859855
          </h1>
          <h2
            className="text-[16px] text-center "
            style={{
              textAlign: "center",
              fontSize: "14px",
              margin: 0,
              padding: 0,
            }}
          >
            {moment(data.date).format("DD.MM.YYYY")}{" "}
            <span
              style={{
                paddingLeft: "8px",
                paddingRight: "8px",
                fontSize: "14px",
              }}
            >
              ЙУЛ ВАРАКАСИ
            </span>{" "}
            № {data.nakladnoy_id}
          </h2>
          {/* <p
            className="text-[16px] text-center"
            style={{ textAlign: "center" }}
          >
            № {data.nakladnoy_id} сонли
          </p> */}

          <section class="info">
            <p
              className=""
              style={{
                fontSize: "14px",
                margin: "4px",
              }}
            >
              {data.status}
            </p>
            <p
              className=""
              style={{
                fontSize: "14px",
                margin: "4px",
              }}
            >
              {data.from_}
            </p>
            <p
              className=""
              style={{
                fontSize: "14px",
                margin: "4px",
              }}
            >
              Автомобиль: {data.auto_number}
            </p>
            <p
              className=""
              style={{
                fontSize: "14px",
                margin: "4px",
              }}
            >
              PNFL: {data.PNFL}
            </p>
            <p
              className=""
              style={{
                fontSize: "14px",
                margin: "4px",
              }}
            >
              Хайдовчи: {data.driver_name}
            </p>
            <p
              className=" uppercase "
              style={{
                fontSize: "14px",
                margin: "4px",
              }}
            >
              <span className=" capitalize text-[14px] ">Етказиб берувчи:</span>{" "}
              "{data.branch_name}" MЧЖ СТИР: {data.branch_INN}
            </p>
            <p
              className=""
              style={{
                fontSize: "14px",
                margin: "4px",
              }}
            >
              олди:{" "}
              <Link
                className=""
                style={{
                  fontSize: "14px",
                  margin: "4px",
                }}
                to={"/customers/" + data.customer_id}
              >
                {data.name}
              </Link>
            </p>
            <p
              className=""
              style={{
                fontSize: "14px",
                margin: "4px",
              }}
            >
              Manzil: {data.where}
            </p>
            {/* <p
              className=""
              style={{
                fontSize: "14px",
                margin: "4px",
              }}
            >
              Санаси: {moment(data.date).format("DD.MM.YYYY")}
            </p> */}
          </section>

          <div className="w-[100%] overflow-auto">
            <table
              style={{
                borderCollapse: "collapse",
                width: "100%",
              }}
              border="1"
              className="text-[14px] max-w-[1200px] w-[100%]"
              cellpadding="10"
            >
              <tr>
                <th
                  className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2 border border-gray-400 px-4 py-2"
                  style={{
                    fontSize: "14px",
                    margin: 0,
                  }}
                >
                  №
                </th>
                <th
                  style={{
                    fontSize: "14px",
                    margin: 0,
                  }}
                  className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2"
                >
                  Юк номи
                </th>
                <th
                  style={{
                    fontSize: "14px",
                    margin: 0,
                  }}
                  className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2"
                >
                  Ўлчов бирлиги
                </th>
                <th
                  style={{
                    fontSize: "14px",
                    margin: 0,
                  }}
                  className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2"
                >
                  Qayerdan
                </th>
                <th
                  style={{
                    fontSize: "14px",
                    margin: 0,
                  }}
                  className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2"
                >
                  {" "}
                  sum (1 qop)
                </th>
                <th
                  style={{
                    fontSize: "14px",
                    margin: 0,
                  }}
                  className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2"
                >
                  Соф огирлик
                </th>
              </tr>
              {data?.products?.map((el, i) => {
                return (
                  <tr
                    style={{
                      fontSize: "14px",
                      margin: 0,
                    }}
                  >
                    <td
                      style={{
                        fontSize: "14px",
                        margin: 0,
                        padding: "4px",
                      }}
                      className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1"
                    >
                      {i + 1}
                    </td>
                    <td
                      style={{
                        fontSize: "14px",
                        margin: 0,
                        padding: 0,
                        paddingLeft: "4px",
                        lineHeight: "14px",
                        padding: "4px",
                      }}
                      className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1"
                    >
                      {el.name}
                    </td>
                    <td
                      style={{
                        fontSize: "14px",
                        margin: 0,
                        padding: 0,
                        paddingLeft: "4px",
                        lineHeight: "14px",
                        padding: "4px",
                      }}
                      className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1"
                    >
                      Tn
                    </td>
                    <td
                      style={{
                        fontSize: "14px",
                        margin: 0,
                        padding: "4px",
                      }}
                      className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1"
                    >
                      {el.from_}
                    </td>
                    <td
                      style={{
                        fontSize: "14px",
                        margin: 0,
                        padding: "4px",
                      }}
                      className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1"
                    >
                      {" "}
                      <Tooltip
                        title={formatNumberWithSpaces(
                          el.price_qop * ((el.tonna * 1000) / 50)
                        )}
                        className="text-[16px]"
                      >
                        {formatNumberWithSpaces(el.price_qop)}
                      </Tooltip>
                    </td>
                    <td
                      style={{
                        fontSize: "14px",
                        margin: 0,
                        padding: 0,
                        paddingLeft: "4px",
                        lineHeight: "14px",
                        padding: "4px",
                      }}
                      className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1"
                    >
                      {formatNumberWithSpaces(el.tonna)} (
                      {formatNumberWithSpaces((el.tonna * 1000) / 50)} qop)
                    </td>
                  </tr>
                );
              })}
            </table>
          </div>

          <footer>
            <div
              className="flex items-center justify-between w-[100%]"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <p className="text-[16px] m-0 p-[3px]">
                Жами миқдори: {numberToWords(sum * 1000)} kg
              </p>
              <p className="text-[16px] m-0 p-[3px]">
                {(sum * 1000) / 50} дона Qop
              </p>
            </div>
            <div
              className="flex items-center justify-between w-[100%] pt-5"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <div className="text-[14px] ">
                <p className="text-[12px] text-[#b4b4b4] m-0 px-0">
                  {" "}
                  Berdi: {data?.given_by?.name} :{data?.given_by?.phone}
                </p>
                <p className="text-[12px] text-[#b4b4b4] m-0 py-1">
                  Yozdi: {data.written_by}
                </p>
                <p className="text-[12px] text-[#b4b4b4] m-0 p-0">
                  Yozildi:{" "}
                  {moment(data.created_at).format("MMMM Do, YYYY h:mm A")}
                </p>
              </div>

              <p className="text-[12px]  w-[50%]" style={{ width: "50%" }}>
                {data.comment}
              </p>
            </div>
            <br />
            <div className="text-[14px] ">
              <p className="text-[12px] text-[#b4b4b4] m-0 px-0">
                {" "}
                Tasdiqladi: {data?.confirm_by}
              </p>
              <p className="text-[12px] text-[#b4b4b4] m-0 py-1">
                Sana: {data?.confirm_at}
              </p>
              <p className="text-[12px] text-[#b4b4b4] m-0 p-0">
                Yozildi:{" "}
                {moment(data.created_at).format("MMMM Do, YYYY h:mm A")}
              </p>
            </div>
          </footer>
        </div>
      </div>

      {/* printable content hidden*/}
      <div className="hidden">
        <div
          ref={elementRef}
          className="hidden flex flex-col gap-6 h-[20px] overflow"
          style={{
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div
            class="max-w-[900px] w-[100%] font-sans"
            style={{
              paddingRight: "20px",
              paddingLeft: "20px",
              paddingBottom: "100px",
              marginTop: "50px",
            }}
          >
            <h1
              className="text-center mt-1"
              style={{
                textAlign: "center",
                fontSize: "14px",
                margin: 0,
                padding: 0,
              }}
            >
              "МИНЕРАЛ МАРКЕТ" MЧЖ СТИР: 310859855
            </h1>
            <h2
              className="text-[16px] text-center "
              style={{
                textAlign: "center",
                fontSize: "14px",
                margin: 0,
                padding: 0,
              }}
            >
              {moment(data.date).format("DD.MM.YYYY")}{" "}
              <span
                style={{
                  paddingLeft: "8px",
                  paddingRight: "8px",
                  fontSize: "14px",
                }}
              >
                ЙУЛ ВАРАКАСИ
              </span>{" "}
              № {data.nakladnoy_id}
            </h2>
            {/* <p
              className="text-[14px] m-0 p-0 pt-1 text-center"
              style={{
                textAlign: "center",
                fontSize: "14px",
                margin: 0,
                padding: 0,
              }}
            >
              № {data.nakladnoy_id} сонли
            </p> */}

            <section class="info">
              <p
                className=""
                style={{
                  fontSize: "14px",
                  margin: "4px",
                }}
              >
                Автомобиль: {data.auto_number}
              </p>
              <p
                className=""
                style={{
                  fontSize: "14px",
                  margin: "4px",
                }}
              >
                Хайдовчи: {data.driver_name}
              </p>
              <p
                className=" uppercase "
                style={{
                  fontSize: "14px",
                  margin: "4px",
                }}
              >
                <span className=" capitalize text-[14px] ">
                  Етказиб берувчи:
                </span>{" "}
                "{data.branch_name}" MЧЖ СТИР: {data.branch_INN}
              </p>
              <p
                className=""
                style={{
                  fontSize: "14px",
                  margin: "4px",
                }}
              >
                Олувчи номи:{" "}
                <Link
                  className=""
                  style={{
                    fontSize: "14px",
                    margin: "4px",
                  }}
                  to={"/customer/" + data.customer_id}
                >
                  {data.name}
                </Link>
              </p>
              <p
                className=""
                style={{
                  fontSize: "14px",
                  margin: "4px",
                }}
              >
                Манзили: {data.where}
              </p>
              {/* <p
                className=""
                style={{
                  fontSize: "14px",
                  margin: "4px",
                }}
              >
                Санаси: {moment(data.date).format("DD.MM.YYYY")}
              </p> */}
              <p
                className=""
                style={{
                  fontSize: "14px",
                  margin: "4px",
                }}
              >
                Ишончнома №{" "}
              </p>
              <p
                className=""
                style={{
                  fontSize: "14px",
                  margin: "4px",
                }}
              >
                Биржа шартномалари №: {Number(data.nakladnoy_id) === 3498 ? "7975779, 7981903, 7981904, 7981905, 7981907, 7981908" : ""}
              </p>
            </section>

            <table
              style={{
                borderCollapse: "collapse",
                width: "100%",
              }}
              border="1"
              className="text-[14px]"
              cellpadding="10"
            >
              <tr>
                <th
                  className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2 border border-gray-400 px-4 py-2"
                  style={{
                    fontSize: "14px",
                    margin: 0,
                  }}
                >
                  №
                </th>
                <th
                  style={{
                    fontSize: "14px",
                    margin: 0,
                  }}
                  className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2"
                >
                  Юк номи
                </th>
                <th
                  style={{
                    fontSize: "14px",
                    margin: 0,
                  }}
                  className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2"
                >
                  Ўлчов бирлиги
                </th>
                <th
                  style={{
                    fontSize: "14px",
                    margin: 0,
                  }}
                  className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2"
                >
                  Тара
                </th>
                <th
                  style={{
                    fontSize: "14px",
                    margin: 0,
                  }}
                  className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2"
                >
                  {" "}
                  Умумий огирлик
                </th>
                <th
                  style={{
                    fontSize: "14px",
                    margin: 0,
                  }}
                  className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2"
                >
                  Соф огирлик
                </th>
              </tr>
              {data?.products?.map((el, i) => {
                return (
                  <tr
                    style={{
                      fontSize: "14px",
                      margin: 0,
                    }}
                  >
                    <td
                      style={{
                        fontSize: "14px",
                        margin: 0,
                        padding: "4px",
                      }}
                      className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1"
                    >
                      {i + 1}
                    </td>
                    <td
                      style={{
                        fontSize: "14px",
                        margin: 0,
                        padding: 0,
                        paddingLeft: "4px",
                        lineHeight: "14px",
                        padding: "4px",
                      }}
                      className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1"
                    >
                      {el.name}
                    </td>
                    <td
                      style={{
                        fontSize: "14px",
                        margin: 0,
                        padding: 0,
                        paddingLeft: "4px",
                        lineHeight: "14px",
                        padding: "4px",
                      }}
                      className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1"
                    >
                      Tn
                    </td>
                    <td
                      style={{
                        fontSize: "14px",
                        margin: 0,
                        padding: "4px",
                      }}
                      className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1"
                    ></td>
                    <td
                      style={{
                        fontSize: "14px",
                        margin: 0,
                        padding: "4px",
                      }}
                      className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1"
                    ></td>
                    <td
                      style={{
                        fontSize: "14px",
                        margin: 0,
                        padding: 0,
                        paddingLeft: "4px",
                        lineHeight: "14px",
                        padding: "4px",
                      }}
                      className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1"
                    >
                      {el.tonna} ({el.tonna * 20} qop)
                    </td>
                  </tr>
                );
              })}
            </table>

            <footer>
              <div
                className="flex items-center justify-between w-[100%]"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <p className="text-[12px] m-0 p-[3px]">
                  Жами миқдори: {numberToWords(sum * 1000)} Kg
                </p>
                <p className="text-[12px] m-0 p-[3px]">
                  {(sum * 1000) / 50} дона Qop
                </p>
              </div>
              <div
                className="flex items-center justify-between w-[100%]"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <p
                  className="text-[12px] "
                  style={{
                    fontSize: "12px",
                    padding: 0,
                    margin: 0,
                  }}
                >
                  Phone: +998 93 894 40 00
                </p>
                <p
                  className="text-[12px] p-0 m-0  w-[50%]"
                  style={{
                    width: "50%",
                    fontSize: "12px",
                    padding: 0,
                    margin: 0,
                  }}
                >
                  Махсулотни ишлаб чиқарувчи томонидан махсус қопларда
                  қадоқанланган холда, сон ва сифати жиҳатдан бутлиги ва
                  тўлиқлигини назоратини қилган тартибда кабул килдим.
                </p>
              </div>
              <div
                className="flex items-center justify-between mt-2"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginTop: "4px",
                }}
              >
                <p
                  className="text-[14px] m-0 p-[3px]"
                  style={{
                    fontSize: "12px",
                    padding: 0,
                    margin: 0,
                  }}
                >
                  ______________А.Abduvaliev
                </p>
                <div>
                  <p
                    className="text-[14px] m-0 p-[3px]"
                    style={{
                      fontSize: "12px",
                      padding: 0,
                      margin: 0,
                      marginTop: "8px",
                    }}
                  >
                    ______________ {data.name}
                  </p>
                  <p
                    className="text-[14px] m-0 pt-[20px]"
                    style={{
                      fontSize: "12px",
                      padding: 0,
                      margin: 0,
                      marginTop: "28px",
                    }}
                  >
                    ______________ {data.driver_name}
                  </p>
                </div>
              </div>
            </footer>
          </div>

          <div
            class="max-w-[900px] w-[100%] font-sans"
            style={{
              paddingTop: "60px",
              padding: "20px",
            }}
          >
            <h1
              className="text-center mt-1"
              style={{
                textAlign: "center",
                fontSize: "14px",
                margin: 0,
                padding: 0,
              }}
            >
              "МИНЕРАЛ МАРКЕТ" MЧЖ СТИР: 310859855
            </h1>
            <h2
              className="text-[16px] text-center "
              style={{
                textAlign: "center",
                fontSize: "14px",
                margin: 0,
                padding: 0,
              }}
            >
              {moment(data.date).format("DD.MM.YYYY")}{" "}
              <span
                style={{
                  paddingLeft: "8px",
                  paddingRight: "8px",
                  fontSize: "14px",
                }}
              >
                ЙУЛ ВАРАКАСИ
              </span>{" "}
              № {data.nakladnoy_id}
            </h2>
            {/* <p
              className="text-[14px] m-0 p-0 pt-1 text-center"
              style={{
                textAlign: "center",
                fontSize: "14px",
                margin: 0,
                padding: 0,
              }}
            >
              № {data.nakladnoy_id} сонли
            </p> */}

            <section class="info">
              <p
                className=""
                style={{
                  fontSize: "14px",
                  margin: "4px",
                }}
              >
                Автомобиль: {data.auto_number}
              </p>
              <p
                className=""
                style={{
                  fontSize: "14px",
                  margin: "4px",
                }}
              >
                Хайдовчи: {data.driver_name}
              </p>
              <p
                className=" uppercase "
                style={{
                  fontSize: "14px",
                  margin: "4px",
                }}
              >
                <span className=" capitalize text-[14px] ">
                  Етказиб берувчи:
                </span>{" "}
                "{data.branch_name}" MЧЖ СТИР: {data.branch_INN}
              </p>
              <p
                className=""
                style={{
                  fontSize: "14px",
                  margin: "4px",
                }}
              >
                Олувчи номи:{" "}
                <Link
                  className=""
                  style={{
                    fontSize: "14px",
                    margin: "4px",
                  }}
                  to={"/customer/" + data.customer_id}
                >
                  {data.name}
                </Link>
              </p>
              <p
                className=""
                style={{
                  fontSize: "14px",
                  margin: "4px",
                }}
              >
                Манзили: {data.where}
              </p>
              {/* <p
                className=""
                style={{
                  fontSize: "14px",
                  margin: "4px",
                }}
              >
                Санаси: {moment(data.date).format("DD.MM.YYYY")}
              </p> */}
              <p
                className=""
                style={{
                  fontSize: "14px",
                  margin: "4px",
                }}
              >
                Ишончнома №{" "}
              </p>
              <p
                className=""
                style={{
                  fontSize: "14px",
                  margin: "4px",
                }}
              >
                Биржа шартномалари №: {Number(data.nakladnoy_id) === 3498 ? "7975779, 7981903, 7981904, 7981905, 7981907, 7981908" : ""}
              </p>
            </section>

            <table
              style={{
                borderCollapse: "collapse",
                width: "100%",
              }}
              border="1"
              className="text-[14px]"
              cellpadding="10"
            >
              <tr>
                <th
                  className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2 border border-gray-400 px-4 py-2"
                  style={{
                    fontSize: "14px",
                    margin: 0,
                  }}
                >
                  №
                </th>
                <th
                  style={{
                    fontSize: "14px",
                    margin: 0,
                  }}
                  className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2"
                >
                  Юк номи
                </th>
                <th
                  style={{
                    fontSize: "14px",
                    margin: 0,
                  }}
                  className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2"
                >
                  Ўлчов бирлиги
                </th>
                <th
                  style={{
                    fontSize: "14px",
                    margin: 0,
                  }}
                  className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2"
                >
                  Тара
                </th>
                <th
                  style={{
                    fontSize: "14px",
                    margin: 0,
                  }}
                  className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2"
                >
                  {" "}
                  Умумий огирлик
                </th>
                <th
                  style={{
                    fontSize: "14px",
                    margin: 0,
                  }}
                  className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2"
                >
                  Соф огирлик
                </th>
              </tr>
              {data?.products?.map((el, i) => {
                return (
                  <tr
                    style={{
                      fontSize: "14px",
                      margin: 0,
                    }}
                  >
                    <td
                      style={{
                        fontSize: "14px",
                        margin: 0,
                        padding: "4px",
                      }}
                      className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1"
                    >
                      {i + 1}
                    </td>
                    <td
                      style={{
                        fontSize: "14px",
                        margin: 0,
                        padding: 0,
                        paddingLeft: "4px",
                        lineHeight: "14px",
                        padding: "4px",
                      }}
                      className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1"
                    >
                      {el.name}
                    </td>
                    <td
                      style={{
                        fontSize: "14px",
                        margin: 0,
                        padding: 0,
                        paddingLeft: "4px",
                        lineHeight: "14px",
                        padding: "4px",
                      }}
                      className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1"
                    >
                      Tn
                    </td>
                    <td
                      style={{
                        fontSize: "14px",
                        margin: 0,
                        padding: "4px",
                      }}
                      className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1"
                    ></td>
                    <td
                      style={{
                        fontSize: "14px",
                        margin: 0,
                        padding: "4px",
                      }}
                      className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1"
                    ></td>
                    <td
                      style={{
                        fontSize: "14px",
                        margin: 0,
                        padding: 0,
                        paddingLeft: "4px",
                        lineHeight: "14px",
                        padding: "4px",
                      }}
                      className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1"
                    >
                      {el.tonna} ({el.tonna * 20} qop)
                    </td>
                  </tr>
                );
              })}
            </table>

            <footer>
              <div
                className="flex items-center justify-between w-[100%]"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <p className="text-[12px] m-0 p-[3px]">
                  Жами миқдори: {numberToWords(sum * 1000)} Kg
                </p>
                <p className="text-[12px] m-0 p-[3px]">
                  {(sum * 1000) / 50} дона Qop
                </p>
              </div>
              <div
                className="flex items-center justify-between w-[100%]"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <p
                  className="text-[12px] "
                  style={{
                    fontSize: "12px",
                    padding: 0,
                    margin: 0,
                  }}
                >
                  Phone: +998 93 894 40 00
                </p>
                <p
                  className="text-[12px] p-0 m-0  w-[50%]"
                  style={{
                    width: "50%",
                    fontSize: "12px",
                    padding: 0,
                    margin: 0,
                  }}
                >
                  Махсулотни ишлаб чиқарувчи томонидан махсус қопларда
                  қадоқанланган холда, сон ва сифати жиҳатдан бутлиги ва
                  тўлиқлигини назоратини қилган тартибда кабул килдим.
                </p>
              </div>
              <div
                className="flex items-center justify-between mt-2"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginTop: "4px",
                }}
              >
                <p
                  className="text-[14px] m-0 p-[3px]"
                  style={{
                    fontSize: "12px",
                    padding: 0,
                    margin: 0,
                  }}
                >
                  ______________А.Abduvaliev
                </p>
                <div>
                  <p
                    className="text-[14px] m-0 p-[3px]"
                    style={{
                      fontSize: "12px",
                      padding: 0,
                      margin: 0,
                      marginTop: "8px",
                    }}
                  >
                    ______________ {data.name}
                  </p>
                  <p
                    className="text-[14px] m-0 pt-[20px]"
                    style={{
                      fontSize: "12px",
                      padding: 0,
                      margin: 0,
                      marginTop: "28px",
                    }}
                  >
                    ______________ {data.driver_name}
                  </p>
                </div>
              </div>
            </footer>
          </div>
        </div>
      </div>
    </div>
  );
}
